/**
 * The keys are what we have configured as langCode(s),
 * and the values are the corresponding keys in moment.js.
 */
export const localeMapping = {
  deDE: 'de',
  enGB: 'en-gb',
  enUS: 'en',
  esES: 'es',
  esMX: 'es',
  frCA: 'fr-ca',
  frFR: 'fr',
  hiIN: 'hi',
  itIT: 'it',
  jaJP: 'ja',
  koKR: 'ko',
  plPL: 'pl',
  ptBR: 'pt-br',
  ptPT: 'pt',
  viVN: 'vi',
  zhCN: 'zh-cn'
};
